import { FormattedMessage } from 'react-intl';

import { DASHBOARD } from '../constants';
import { Reports } from '../reports';
import { ANALYTICS_NAV_ITEM_ID, EXPLORE_NAV_ITEM_ID } from './constants';
import { CarrierPerformance } from './dashboards/carrier-performance';
import { ConversationalAnalyticsPage } from './dashboards/conversational-analytics/conversational-analytics-page';
// import { ExploreCustomers } from './dashboards/explore-customers'; // Uncomment when BI builds fct_customers
import { ExploreInventory } from './dashboards/explore-inventory';
import { ExploreOrders } from './dashboards/explore-orders';
import { ExploreReturns } from './dashboards/explore-returns';
import { ExploreShipments } from './dashboards/explore-shipments';
import { InventoryOverview } from './dashboards/inventory-overview';
import { OrderProcessing } from './dashboards/order-processing';
import { ProfitabilityOptimization } from './dashboards/profitability-optimization';
import { ReturnShipments } from './dashboards/return-shipments';
import { ShipmentTracking } from './dashboards/shipment-tracking';
import { WarehousePerformance } from './dashboards/warehouse-performance';
import { leftNavMessages } from './messages';

export const SHIPMENT_OVERVIEW_PAGES = [
  {
    id: ANALYTICS_NAV_ITEM_ID.carrierPerformance,
    label: <FormattedMessage {...leftNavMessages.carrierPerformance} />,
    location: ANALYTICS_NAV_ITEM_ID.carrierPerformance,
    path: `/${DASHBOARD}/${ANALYTICS_NAV_ITEM_ID.carrierPerformance}`,
    Component: CarrierPerformance,
    isLooker: true,
  },
  {
    id: ANALYTICS_NAV_ITEM_ID.shipmentTracking,
    label: <FormattedMessage {...leftNavMessages.shipmentTracking} />,
    location: ANALYTICS_NAV_ITEM_ID.shipmentTracking,
    path: `/${DASHBOARD}/${ANALYTICS_NAV_ITEM_ID.shipmentTracking}`,
    Component: ShipmentTracking,
    isLooker: true,
  },
  {
    id: ANALYTICS_NAV_ITEM_ID.profitabilityOptimization,
    label: <FormattedMessage {...leftNavMessages.profitabilityOptimization} />,
    location: ANALYTICS_NAV_ITEM_ID.profitabilityOptimization,
    path: `/${DASHBOARD}/${ANALYTICS_NAV_ITEM_ID.profitabilityOptimization}`,
    Component: ProfitabilityOptimization,
    isLooker: true,
  },
  {
    id: ANALYTICS_NAV_ITEM_ID.returnShipments,
    label: <FormattedMessage {...leftNavMessages.returnShipments} />,
    location: ANALYTICS_NAV_ITEM_ID.returnShipments,
    path: `/${DASHBOARD}/${ANALYTICS_NAV_ITEM_ID.returnShipments}`,
    Component: ReturnShipments,
    isLooker: true,
  },
];

export const ORDER_OVERVIEW_PAGES = [
  {
    id: ANALYTICS_NAV_ITEM_ID.orderProcessing,
    label: <FormattedMessage {...leftNavMessages.orderProcessing} />,
    location: ANALYTICS_NAV_ITEM_ID.orderProcessing,
    path: `/${DASHBOARD}/${ANALYTICS_NAV_ITEM_ID.orderProcessing}`,
    Component: OrderProcessing,
    isLooker: true,
  },
];

export const STANDALONE_PAGES = [
  {
    id: ANALYTICS_NAV_ITEM_ID.salesAndCustomers,
    label: <FormattedMessage {...leftNavMessages.salesAndCustomers} />,
    location: ANALYTICS_NAV_ITEM_ID.salesAndCustomers,
    path: `/${DASHBOARD}/${ANALYTICS_NAV_ITEM_ID.salesAndCustomers}`,
    selected: false,
    isLooker: false,
  },
  {
    id: ANALYTICS_NAV_ITEM_ID.products,
    label: <FormattedMessage {...leftNavMessages.products} />,
    location: ANALYTICS_NAV_ITEM_ID.products,
    path: `/${DASHBOARD}/${ANALYTICS_NAV_ITEM_ID.products}`,
    selected: false,
    isLooker: false,
  },
  {
    id: ANALYTICS_NAV_ITEM_ID.warehouses,
    label: <FormattedMessage {...leftNavMessages.warehouses} />,
    location: ANALYTICS_NAV_ITEM_ID.warehouses,
    path: `/${DASHBOARD}/${ANALYTICS_NAV_ITEM_ID.warehouses}`,
    selected: false,
    Component: WarehousePerformance,
    isLooker: true,
  },
  {
    id: ANALYTICS_NAV_ITEM_ID.inventory,
    label: <FormattedMessage {...leftNavMessages.inventory} />,
    location: ANALYTICS_NAV_ITEM_ID.inventory,
    path: `/${DASHBOARD}/${ANALYTICS_NAV_ITEM_ID.inventory}`,
    selected: false,
    Component: InventoryOverview,
    isLooker: true,
  },
  {
    id: ANALYTICS_NAV_ITEM_ID.reports,
    label: <FormattedMessage {...leftNavMessages.reports} />,
    location: ANALYTICS_NAV_ITEM_ID.reports,
    path: `/${DASHBOARD}/${ANALYTICS_NAV_ITEM_ID.reports}`,
    selected: false,
    isLooker: false,
    Component: Reports,
  },
];

export const DATA_EXPLORER_PAGES = [
  {
    id: EXPLORE_NAV_ITEM_ID.exploreShipments,
    label: <FormattedMessage {...leftNavMessages.exploreShipments} />,
    location: EXPLORE_NAV_ITEM_ID.exploreShipments,
    path: `/${DASHBOARD}/${EXPLORE_NAV_ITEM_ID.exploreShipments}`,
    Component: ExploreShipments,
    isLooker: true,
  },
  {
    id: EXPLORE_NAV_ITEM_ID.exploreOrders,
    label: <FormattedMessage {...leftNavMessages.exploreOrders} />,
    location: EXPLORE_NAV_ITEM_ID.exploreOrders,
    path: `/${DASHBOARD}/${EXPLORE_NAV_ITEM_ID.exploreOrders}`,
    Component: ExploreOrders,
    isLooker: true,
  },
  // Uncomment when BI builds the fct_customers explore in Looker
  // {
  //   id: EXPLORE_NAV_ITEM_ID.exploreCustomers,
  //   label: <FormattedMessage {...leftNavMessages.exploreCustomers} />,
  //   location: EXPLORE_NAV_ITEM_ID.exploreCustomers,
  //   path: `/${DASHBOARD}/${EXPLORE_NAV_ITEM_ID.exploreCustomers}`,
  //   Component: ExploreCustomers,
  //   isLooker: true,
  // },
  {
    id: EXPLORE_NAV_ITEM_ID.exploreInventory,
    label: <FormattedMessage {...leftNavMessages.exploreInventory} />,
    location: EXPLORE_NAV_ITEM_ID.exploreInventory,
    path: `/${DASHBOARD}/${EXPLORE_NAV_ITEM_ID.exploreInventory}`,
    Component: ExploreInventory,
    isLooker: true,
  },
  {
    id: EXPLORE_NAV_ITEM_ID.exploreReturns,
    label: <FormattedMessage {...leftNavMessages.exploreReturns} />,
    location: EXPLORE_NAV_ITEM_ID.exploreReturns,
    path: `/${DASHBOARD}/${EXPLORE_NAV_ITEM_ID.exploreReturns}`,
    Component: ExploreReturns,
    isLooker: true,
  },
];

export const ANALYTICS_NAV_ITEMS = [
  {
    id: ANALYTICS_NAV_ITEM_ID.conversationalAnalytics,
    label: <FormattedMessage {...leftNavMessages.conversationalAnalytics} />,
    location: ANALYTICS_NAV_ITEM_ID.conversationalAnalytics,
    path: `/${DASHBOARD}/${ANALYTICS_NAV_ITEM_ID.conversationalAnalytics}`,
    selected: false,
    Component: ConversationalAnalyticsPage,
    isLooker: true,
    isConversationalAnalytics: true,
  },
  {
    id: ANALYTICS_NAV_ITEM_ID.shipmentOverview,
    label: <FormattedMessage {...leftNavMessages.shipmentOverview} />,
    location: ANALYTICS_NAV_ITEM_ID.shipmentOverview,
    path: `/${DASHBOARD}/${ANALYTICS_NAV_ITEM_ID.shipmentOverview}`,
    expanded: true,
    items: SHIPMENT_OVERVIEW_PAGES,
    selected: true,
    isLooker: false,
  },
  {
    id: ANALYTICS_NAV_ITEM_ID.orderOverview,
    label: <FormattedMessage {...leftNavMessages.orderOverview} />,
    location: ANALYTICS_NAV_ITEM_ID.orderOverview,
    path: `/${DASHBOARD}/${ANALYTICS_NAV_ITEM_ID.orderOverview}`,
    expanded: true,
    items: ORDER_OVERVIEW_PAGES,
    selected: false,
    isLooker: false,
  },
  ...STANDALONE_PAGES,
  {
    id: EXPLORE_NAV_ITEM_ID.dataExplorer,
    label: <FormattedMessage {...leftNavMessages.dataExplorer} />,
    location: EXPLORE_NAV_ITEM_ID.dataExplorer,
    path: `/${DASHBOARD}/${EXPLORE_NAV_ITEM_ID.dataExplorer}`,
    expanded: true,
    items: DATA_EXPLORER_PAGES,
    selected: false,
    isLooker: true,
  },
];

export const LOOKER_PAGES = [...ANALYTICS_NAV_ITEMS, ...SHIPMENT_OVERVIEW_PAGES, ...ORDER_OVERVIEW_PAGES, ...DATA_EXPLORER_PAGES];
